import { useReducer, type ReactNode } from 'react';
import { appReducer, initialState } from './reducer';
import { AppStateContext } from './context';

// Only export the component and hook from this file
export const AppStateProvider = ({ children }: { children: ReactNode }) => {
    const [state, dispatch] = useReducer(appReducer, initialState);

    return <AppStateContext.Provider value={{ state, dispatch }}>{children}</AppStateContext.Provider>;
};
